export default {
  state: () => ({
    data: {
      doShowMiniBanner: false,
      showItems: [],
      isShow: true,
      showNextItemTimeOut: 30,
    },
  }),
  mutations: {
    'footerMiniBanner/setState'(state, payload) {
      state.data = { ...state.data, ...payload };
    },
    'footerMiniBanner/setDoShowMiniBanner'(state, payload) {
      state.data = { ...state.data, isShowMiniBanner: payload };
    },
    'footerMiniBanner/setIsShow'(state, payload) {
      state.data = { ...state.data, isShow: payload };
    },
  },
  actions: {
    async 'footerMiniBanner/refresh'({ commit, state, rootState, getters }, payload) {
      try {
        const catalogSectionId = rootState?.catalog?.data?.catalogSectionList?.section?.id;
        const holidayId = rootState?.catalog?.data?.holiday?.id;
        const blogElementId = rootState?.results?.blogElement?.id;
        const actionId = rootState?.results?.action?.id;
        const newsElementId = rootState?.results?.newsElement?.id;
        const lang = getters.getCurrentLang;

        const cabinetPagesItems = state?.data?.items?.filter((el) => {
          // const sitePages = [...el?.cabinetPages, ...el?.servicePages];
          const showInCabinetItems = el?.cabinetPages?.filter((cabinetPage) => {
            const cabinetPageByLocale = lang.default ? cabinetPage : `/${lang.code}${cabinetPage}`;
            return payload === cabinetPageByLocale;
          });
          return showInCabinetItems.length > 0;
        });
        const cabinetPagesItemsIDs = cabinetPagesItems?.map((el) => el.id);

        const items = state?.data?.items?.filter(
          (el) =>
            el?.catalogIDs?.includes(`${catalogSectionId}`) ||
            el?.holidaysIDs?.includes(`${holidayId}`) ||
            el?.blogIDs?.includes(`${blogElementId}`) ||
            el?.actionsIDs?.includes(`${actionId}`) ||
            el?.newsIDs?.includes(`${newsElementId}`) ||
            el?.isShowInService ||
            cabinetPagesItemsIDs?.includes(el.id)
        ); // el?.isShowInCabinet || - commented because it break ajax cabinet loading

        commit('footerMiniBanner/setState', {
          showItems: items,
          doShowMiniBanner: items?.length > 0,
        });
      } catch (err) {
        console.error(err);
      }
    },

    async 'footerMiniBanner/handlerRemove'({ commit, state, rootState, getters }, payload) {
      try {
        const item = getters['footerMiniBanner/getItem'];
        const id = item?.id;
        if (id) {
          /**
           * could be done by storage in array of banner ids, but it is what it is. Dimon, Borshaga, im really sorry...
           */
          window.sessionStorage.setItem(`isLyFooterMiniBanner${id}WasShown`, true);
          const nextBanner = state?.data?.showItems?.filter(
            (el) =>
              el?.id !== id &&
              !window.sessionStorage.getItem(`isLyFooterMiniBanner${el?.id}WasShown`)
          )[0];
          commit('footerMiniBanner/setIsShow', false);

          if (nextBanner?.id > 0) {
            const showAfter = new Date();
            showAfter.setSeconds(showAfter.getSeconds() + state?.data?.showNextItemTimeOut);
            window.sessionStorage.setItem(
              `lyFooterMiniBanner${nextBanner?.id}ShowAfter`,
              showAfter
            );
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  getters: {
    'footerMiniBanner/getItem': (state) => {
      try {
        return state?.data?.showItems?.filter((el) => {
          const isShowByInterval = window.sessionStorage.getItem(
            `lyFooterMiniBanner${el?.id}ShowAfter`
          );
          return (
            !window.sessionStorage.getItem(`isLyFooterMiniBanner${el?.id}WasShown`) &&
            new Date(isShowByInterval) <= new Date()
          );
        })[0];
      } catch (err) {
        console.log(err);
      }
    },
    'footerMiniBanner/getIsShow': (state) => {
      try {
        return state?.data?.isShow;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
